module.exports = __webpack_public_path__ + "img/payment_term_white.1e6ef92.svg";